import { useTranslation } from 'react-i18next';

import { AnimatedRoutedDrawer } from 'src/Components/Drawers/AnimatedRoutedDrawer';
import { PracticalInformationCreationFormWrapper } from 'src/Components/Forms/PracticalInformation/PracticalInformationCreationFormWrapper';
import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';

const CreatePracticalInformationDrawer = () => {
  const { t } = useTranslation();

  const assetId = useCurrentAssetId();

  return (
    <AnimatedRoutedDrawer
      title={t(
        'practicalInformation.createPracticalInformation',
        'Ajouter une information pratique'
      )}
      to={`/asset/${assetId}/infos/practical-info`}
    >
      {({ onClose }) => (
        <PracticalInformationCreationFormWrapper onCreate={onClose} onCancel={onClose} />
      )}
    </AnimatedRoutedDrawer>
  );
};

export default CreatePracticalInformationDrawer;
